// --- Custom SVG Components for Hand-Drawn Accents ---
export const ArrowGreenLeftIcon = () => (
	<svg
		viewBox="0 0 100 100"
		className="w-full h-full text-[#CCFF00] stroke-current overflow-visible"
		fill="none"
		strokeWidth="6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M10,90 C 10,40 40,20 60,50 C 70,65 80,75 95,70" />
		<path d="M80,55 L95,70 L85,85" />
	</svg>
);

export const ArrowGreenRightIcon = () => (
	<svg
		viewBox="0 0 100 100"
		className="w-full h-full text-[#CCFF00] stroke-current overflow-visible"
		fill="none"
		strokeWidth="6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M90,10 C 80,60 60,80 40,60 C 20,40 40,20 60,30 C 80,40 70,70 50,80" />
		<path d="M65,75 L50,80 L55,65" />
	</svg>
);

export const ArrowBlack1Icon = () => (
	<svg
		viewBox="0 0 100 100"
		className="w-full h-full text-primary stroke-current overflow-visible"
		fill="none"
		strokeWidth="5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M20,80 Q 40,20 80,40" />
		<path d="M60,20 L80,40 L50,60" />
	</svg>
);

export const ArrowBlack2Icon = () => (
	<svg
		viewBox="0 0 100 100"
		className="w-full h-full text-primary stroke-current overflow-visible"
		fill="none"
		strokeWidth="5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M20,80 Q 40,20 80,40" />
		<path d="M60,20 L80,40 L50,60" />
	</svg>
);
